import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Promocao from 'components/promocao';

import { Link } from 'react-router-dom';

const CarrosselPromocoes = ({ lpromocoes }) => {

  const responsive = {
    superLargeDesktop: {
      // screens larger than 1920px
      breakpoint: { max: 4000, min: 1920 },
      items: 4
    },
    desktop: {
      // screens larger than 1024px
      breakpoint: { max: 1920, min: 1024 },
      items: 4
    },
    tablet: {
      // screens larger than 464px
      breakpoint: { max: 1024, min: 768 },
      items: 3
    },
    mobile: {
      // screens smaller than 464px
      breakpoint: { max: 768, min: 0 },
      items: 1
    }
  };

  return <>
    <div className='mt-3'>
      <h1 id="Promocoes">
        Promoções
      </h1>
      <Carousel responsive={responsive} infinite={true} className="mt-3">
        {lpromocoes.map(b => (
          <div key={`promo${b.id_promocao}`} className='p-2'>
            <Promocao
              promocao={b}
              index={b.id_promocao}
            />
          </div>
        ))}
      </Carousel>
    </div>
  </>
};

export default CarrosselPromocoes;
